// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LazyImageStyle } from "@insite/mobius/LazyImage";
import { listStyles } from "@west/Overrides/Widgets/Brand/BrandGallery";
import { xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

listStyles.titleText = {
    variant: "h2",
    css: css`
        letter-spacing: 0;
        line-height: 30px;
        margin-bottom: 18px;
    `,
};

listStyles.imageContainer = {
    css: css`
        &.carousel {
            .swiper-slide {
                display: flex;
                align-items: center;
                max-width: 140px;
                max-height: 140px;
                padding: 4px;
            }
            & div.brand-item {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        &.list-desktop {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: wrap;
            gap: 20px 22px;

            & > div.brand-item > .brand-item-link {
                justify-content: center;
                padding: 0;
                height: 102px;
                width: 204px;

                ${LazyImageStyle} {
                    height: 100%;
                }

                ${xScreen("lte", "md")} {
                    height: 78px;
                    width: 156px;
                }
            }
        }
    `,
};

listStyles.imageItem = {};

listStyles.image = {
    mergeCss: true,
    css: css`
        width: 100%;
    `,
    imgProps: {
        height: "140px",
        width: "140px",
        style: {
            objectFit: "contain",
            width: "100%",
            height: "100%",
        },
    },
};
